var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 6,
    fill: "#C32829"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.9231,
    y: 5.9231,
    width: 9.30769,
    height: 9.30769,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_85_126",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_85_126",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgEAQAAACJ4248AAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAAAqo0jMgAAAAlwSFlzAAAAYAAAAGAA8GtCzwAAAAd0SU1FB+cEBBINEArMqToAAAEySURBVFjDvde9ioNAFEDhYd/L0reIXYIjSRWw8UUtLIREECwCIXXu2cL9dwyO3ru3lpxvZJwhDkkSpK7hckF2O2c8SJbB9YrUNZIkDpqGrxGBojCLUxRj43OaxsEw8GtsENM4wDA4JM+ZjC4iHAckzz8eOJ+DCDmdNsflcIDnc/r7VfVHqY9YHLdARMc1EavjGojN8S0ItfgahHo8BmEWX4Iwj3+vsiyDiOAJV5aq8ddvwnjlcYj4+Fu84PFwTiREc+5+t1397Ib7uSeOR5s43gc3XBDh/T+tvKpmP1GtN7HkOzdDxBwy6ghkv4894dQQa+JqiC3xzQiN+GqEZjwaYRFfjBj/q9leqbNXuWSZg763jL9G9L2DtrWOzyPa1iFpCl0Ht5v6JRJC4P3Y6jokTd8BD/alT8z1k1wAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMDQtMDRUMTg6MTM6MTYrMDA6MDBKcumrAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTA0LTA0VDE4OjEzOjE2KzAwOjAwOy9RFwAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMy0wNC0wNFQxODoxMzoxNiswMDowMGw6cMgAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDropdown);
export default __webpack_public_path__ + "static/media/close_dropdown.89966b9b6e2d0c35d5840d7709dd870e.svg";
export { ForwardRef as ReactComponent };